<template>
    <CodiceFeanorView tool-module="symmetric" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
